<template>
	<div class="tplContainer">
		<div class="width1200">
			<div v-if="showtype==1">
				<p class="tpltitle">视频图文转链接二维码，私域项目收款与交付</p>
				<div class="tpllists">
					
					<div class="tplinfo">
						<p class="tplinfo1">视频转链接/二维码</p>
						<div class="tplinfo2">
							<span>1080P无损高清播放</span>
							<div class="cutline"></div>
							<span>一次转换终生有效</span>
							<div class="cutline"></div>
							<span>转换后支持更换视频</span>
						</div>
						<div class="tplinfo3">
							<div>无标识小程序打开模式</div>
							<div>h5网页打开模式</div>
							<div>提片小程序打开模式</div>
						</div>
						<!-- <button class="tplbutton" @click="tovideoComponents()">上传视频</button> -->
						<a-button class="tplbutton essential-color-main-btn" type="primary" size="large" shape="round" @click="tovideoComponents()">上传视频</a-button>
						<span class="mbm-iconfont mbm-shipin tplicon"></span>
					</div>
					<div class="tplinfo">
						<p class="tplinfo1">付费超级编辑器</p>
						<div class="tplinfo2">
							<span>内容组件自由组合</span>
							<div class="cutline"></div>
							<span>支付规则独立设置</span>
							<div class="cutline"></div>
							<span>一键生成链接与二维码</span>
						</div>
						<div class="tplinfo3">
							<div>搭建项目成交页面</div>
							<div>制作付费内容专栏</div>
							<div>创建社群会员入口</div>
						</div>
						<!-- <button class="tplbutton" @click="tovideoComponents()">上传视频</button> -->
						<a-button class="tplbutton essential-color-main-btn" type="primary" size="large" shape="round" @click="skipGedit">立即制作</a-button>
						<img class="imgimg" :src="homeBannerImg" alt="">
					</div>
				</div>
				<div class="tpllists" style="margin-top: 40px;">
					<div class="tplinfo">
						<p class="tplinfo1">视频、课程付费</p>
						<div class="tplinfo2">
							<span>一键上传视频极速审核</span>
							<div class="cutline"></div>
							<span>多种打开模式自由定价</span>
							<div class="cutline"></div>
							<span>1080P无损高清播放</span>
						</div>
						<div class="tplinfo3">
							<div>无标识小程序打开模式</div>
							<div>h5网页打开模式</div>
							<div>提片小程序打开模式</div>
						</div>
						<a-button class="tplbutton essential-color-main-btn" type="primary" size="large" shape="round" @click="skipKnowledge">立即制作</a-button>
						<span class="mbm-iconfont mbm-zhishi tplicon tp-icon-zhishi"></span>
					</div>
					<div class="tplinfo">
						<p class="tplinfo1">图片付费</p>
						<div class="tplinfo2">
							<span>多种图片格式支持</span>
							<div class="cutline"></div>
							<span>支持图片试看设置</span>
							<div class="cutline"></div>
							<span>一次转换长期有效</span>
						</div>
						<div class="tplinfo3">
							<div>无标识小程序打开模式</div>
							<div>h5网页打开模式</div>
							<div>提片小程序打开模式</div>
						</div>
						<!-- <button class="tplbutton" @click="tovideoComponents()">上传视频</button> -->
						<a-button class="tplbutton essential-color-main-btn" type="primary" size="large" shape="round" @click="skipKnowledgeImg">立即制作</a-button>
						<span class="mbm-iconfont mbm-tupian tplicon" style="bottom: 16px;color: #fae1cf;"></span>
					</div>
				</div>
				<div class="tpllists" style="margin-top: 40px;">
					
					<div class="tplinfo">
						<p class="tplinfo1">资料付费</p>
						<div class="tplinfo2">
							<span>资料即传即用</span>
							<div class="cutline"></div>
							<span>加密存储安全无忧</span>
							<div class="cutline"></div>
							<span>一次转换长期有效</span>
						</div>
						<div class="tplinfo3">
							<div>无标识小程序打开模式</div>
							<div>h5网页打开模式</div>
							<div>提片小程序打开模式</div>
						</div>
						<a-button class="tplbutton essential-color-main-btn" type="primary" size="large" shape="round" @click="skipKnowledgeFile">立即制作</a-button>
						<span class="mbm-iconfont mbm-muludakai tplicon tp-icon-zhishi" style="color: #d5eaf8;bottom: 13px;"></span>
					</div>
					<div class="tplinfo">
						<p class="tplinfo1">付费超级编辑器（海外版）</p>
						<div class="tplinfo2">
							<span>自由组合内容组件</span>
							<div class="cutline"></div>
							<span>灵活设置海外支付</span>
							<div class="cutline"></div>
							<span>一键生成链接与二维码</span>
						</div>
						<div class="tplinfo3">
							<div>Visa / Mastercard </div>
							<div>PayPal快捷支付</div>
							<div>Apple Pay / Google Pay</div>
						</div>
						<a-button class="tplbutton essential-color-main-btn dev" disabled type="primary" size="large" shape="round">开发中·敬请期待</a-button>
						<img class="imgimg" :src="homeBannerImg2" alt="">
					</div>
				</div>
				<div class="tplBottom">
					<div class="tplBottomL">
						<p class="tplBottomL1">企业专属服务</p>
						<p class="tplBottomL2">企业大规模应用，专属小程序定制服务 | 详情咨询：400-963-7018</p>
					</div>
					<div class="tplBottomR" @click="toContact">
						→
					</div>
				</div>
				<!-- 模板列表 -->
				<div v-if="homeTplList.length" class="tplLists" >
					<div class="tplLists__head">
						<h2 class="tplLists__title">精选模板上新，让好项目快速落地</h2>
					</div>
					<div class="tpl-list">
						<article
							v-for="item in homeTplList"
							:key="item.id"
							class="tpl-card"
							@click="onHomeTplClick(item)"
						>
							<div class="tpl-card__phone">
								<div class="tpl-card__phone-inner">
									<img
										v-if="item.cover"
										class="tpl-card__screen"
										:src="item.cover"
										:alt="item.title"
									/>
								</div>
							</div>
							<div class="tpl-card__content">
								<div v-if="item.isHot" class="tpl-card__top">
									<span class="tpl-card__tag">
										<i class="mbm-iconfont mbm-shoucang tpl-card__tag-icon"></i>
										热门模板
									</span>
								</div>
								<h2 class="tpl-card__title">{{ item.title }}</h2>
								<p v-if="item.subtitle" class="tpl-card__desc">{{ item.subtitle }}</p>
								<div v-if="item.features && item.features.length" class="tpl-card__features">
									<template
										v-for="(feature, idx) in item.features.slice(0, 3)"
										:key="idx"
									>
										<div class="tpl-card__feature-row">
											<span class="tpl-card__feature-num">0{{ idx + 1 }}</span>
											<div class="tpl-card__feature-text-box">
												<div class="tpl-card__feature-text">{{ feature.title }}</div>
												<div v-if="feature.subtitle" class="tpl-card__feature-sub">{{ feature.subtitle }}</div>
											</div>
										</div>
										<span
											v-if="idx < Math.min(item.features.length, 3) - 1"
											:key="'arrow-' + idx"
											class="tpl-card__feature-arrow"
										>›</span>
									</template>
								</div>
								<div v-if="item.stats && item.stats.length" class="tpl-card__stats">
									<div
										v-for="(stat, idx) in item.stats"
										:key="idx"
										class="tpl-card__stat"
									>
										<span
											v-if="stat.icon"
											class="mbm-iconfont tpl-card__stat-icon"
											:class="stat.icon"
										></span>
										<div class="tpl-card__stat-body">
											<div class="tpl-card__stat-title">{{ stat.title }}</div>
											<div v-if="stat.subtitle" class="tpl-card__stat-sub">{{ stat.subtitle }}</div>
										</div>
									</div>
								</div>
								<div class="tpl-card__footer">
									<span class="tpl-card__preview-link">预览模板详情 →</span>
								</div>
							</div>
						</article>
					</div>
				</div>
			</div>
			<videotpl v-if="showtype==2" :dataChange="dataChange" :generated="generated" :extra='extra' :videoData="videoData" @showMedialists="showMedialists"></videotpl>
			<audiotpl v-if="showtype==3" :dataChange="dataChange" :generated="generated" :extra='extra' :videoData="videoData" @showMedialists="showMedialists"></audiotpl>
			<a-modal  :destroyInClose="true"  cancelText="取消" okText="确认" :centered="true" :visible="visible" @ok="handleOk" @cancel="handleCancle" title="选择文件" width="92%" :destroyOnClose="true"
				wrapClassName="full-modal">
				<div style="width: 100%; height: calc(100vh - 248px);">
					<videoManage v-if="showtype==2" :isPageOrModel="isPageOrModel" @getlistsfromLib="getlistsfromLib"></videoManage>
					<audioManage v-if="showtype==3" :isPageOrModel="isPageOrModel" @getlistsfromLib="getlistsfromLib"></audioManage>
				</div>	
			</a-modal>
		</div>
	</div>
</template>

<script>
	import videotpl from "/src/components/video.vue";
	import audiotpl from "../../components/audio.vue";
	import { img } from '../../gEdit/utils/localAssets.js';
	import {
		getTemplateDetailUrl,
		getTemplateListUrl,
		normalizeTplListItem,
	} from '../../gEdit/utils/pageTemplate.js';
	import videoManage from '../videoManage/App.vue';
	import audioManage from '../audioManage/App.vue';
	import config from "../../config/config.js";
	import {
		message
	} from 'ant-design-vue';
	export default {
		name: 'Home',
		components: {
			videotpl,
			audiotpl,
			videoManage,
			audioManage,
		},
		data() {
			return {
				isPageOrModel: 2,
				visible: false,
				extra:{
					path:'',
					qrcode_url:''
				},
				showtype: 1, //1默认页面，2视频上传，3音频上传
				homeTplList: [],
				videoData: {
					change_type: 2, //转换形式:1二维码，2链接
					mode: 1, //打开方式:1小程序，2无标识小程序，3h5
					design: 1, //视频款式:1标准，2视频集，3视频刷一刷
					title: '',
					bjcolor: "#ffffff",
					/*背景色*/
					url_info: {
						url_type: 1, //域名:1默认，2vip，3自有
						url: ''
					},
					lists: [], //
				},
				libLists: [], //从附件库选择的附件
				generated:{
					generated:false,
					
				},
				dataChange:{
					dataChange:true,
					
				},
				id_keyuse:''
			}
		},
		methods: {
			toContact(){
				window.open(config.baseURL+'/help/3',"_blank");
			},
			getlistsfromLib(e) {
				this.libLists = e;
			},
			showMedialists(e) {
				this.visible = e;
			},
			handleOk(e) {
				var ids = this.libLists.join(',');
				this.getOneFileData(ids)
				this.visible = false;
			},
			handleCancle() {
				this.visible = false;
			},
			tovideoComponents: function() {
				this.showtype = 2
			},
			toaudioComponents: function() {
				this.showtype = 3
			},
			skipKnowledge: function() {
				if(config.devEnv=='dev'){
					window.open('/knowledgePayment.html');
				}else{
					window.open('https://dp.tipian.com');
				}
			},
			skipKnowledgeImg(){
				if(config.devEnv=='dev'){
					window.open('/knowledgeImgPayment.html');
				}else{
					window.open('https://dp.tipian.com/tu');
				}
			},
			skipKnowledgeFile(){
				if(config.devEnv=='dev'){
					window.open('/knowledgeFilePayment.html');
				}else{
					window.open('https://dp.tipian.com/file');
				}
			},
			skipGedit(){
				if(config.devEnv=='dev'){
					window.open('/gEdit.html');
				}else{
					window.open(config.mianDomain+'/edit');
				}
			},
			skipTplList() {
				window.open(getTemplateListUrl(), '_blank');
			},
			onHomeTplClick(item) {
				if (!item?.id) return;
				window.open(getTemplateDetailUrl(item), '_blank');
			},
			fetchHomeTplList() {
				this.$apiRequest.post('/tpl/lists', {
					keyword: '',
					page: 1,
					size: 5,
					status: 1,
					tag_id: '',
				}).then((res) => {
					if (res?.data?.code !== 200) return;
					const list = Array.isArray(res.data.data) ? res.data.data : [];
					this.homeTplList = list.slice(0, 5).map(normalizeTplListItem);
				}).catch(() => {
					this.homeTplList = [];
				});
			},
			getMediaData(id_key) {
				this.generated.generated=true;
				this.dataChange.dataChange=false;
				this.$apiRequest.post('/qrcode/getQrcodeList', {
					id_key: id_key
				}).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						for(let i=0;i<res.data.data.content.lists.length;i++){
							res.data.data.content.lists[i].upload_hanlde={
								progress:101,
							}
						}
						this.videoData = res.data.data.content;
						this.extra=res.data.extra;
						if (res.data.type == 'video') {
							this.showtype = 2
						} else if (res.data.type = 'audio') {
							this.showtype = 3
						}
					}
				}).catch(err => {
					// message.error(err.message);
				})
			},
			getOneFileData(file_keys) {
				// this.generated.generated=false;
				this.$apiRequest.post('/qrcode/getBatchAttachInfor', {
					file_keys: file_keys
				}).then(res => {
					if (res.data.code == 200) {
						var arr = [];
						for (var i = 0; i < res.data.data.files.length; i++) {
							arr.push({
								id: res.data.data.files[i].id,
								sort: 0,
								title: res.data.data.files[i].filename,
								desc: "",
								cover: {
									id: 0,
									url: "",
								},
								filesize: res.data.data.files[i].filesize,
								url: res.data.data.files[i].url,
								width: res.data.data.files[i].width,
								height: res.data.data.files[i].height,
								duration: res.data.data.files[i].duration,
								extra: {
									title: "",
									desc: "",
									show_desc: 1,
									play_amount_set: 0,
									avatar: {
										id: 0,
										url: "",
									}
								},
								upload_hanlde:{
									progress:101,
								},
							})
						}

						this.videoData.lists = this.videoData.lists.concat(arr);
						if (res.data.data.type == 2) {
							this.showtype = 2
						} else if (res.data.data.type = 4) {
							this.showtype = 3
						}
					}

				}).catch(rres => {
					message.error(err.message);
				})
			}
		},
		computed: {
			homeBannerImg() {
				return img('index-1.png');
			},
			homeBannerImg2() {
				return img('index-2.png');
			}
		},
		watch:{
			videoData:{
				deep:true,
				handler(newval,oldval){
					if(this.id_keyuse!=''){
						this.dataChange.dataChange=false;
						this.id_keyuse='';
					}else{
						this.dataChange.dataChange=true;
					}
				}
			}
		},
		mounted() {
			this.fetchHomeTplList();
			var url = location.search;
			if (url.indexOf('?') != -1) { //判断是否有参数
				let arr = []; // 存储参数的数组
				let res = {}; // 存储最终JSON结果对象
				arr = url.split('?')[1].split('&'); // 获取浏览器地址栏中的参数
				for (let i = 0; i < arr.length; i++) { // 遍历参数
					if (arr[i].indexOf('=') != -1) { // 如果参数中有值
						let str = arr[i].split('=');
						res[str[0]] = str[1];
					} else { // 如果参数中无值
						res[arr[i]] = '';
					}
				}
				if (res.id_key !== undefined) {
					this.getMediaData(res.id_key)
					this.id_keyuse=res.id_key;//临时用
				} else if (res.file_keys !== undefined) {
					this.getOneFileData(res.file_keys)
					this.videoData.change_type=parseInt(res.change_type)
				}
			}
		}
	}
</script>

<style>
	.dev{
		background-color: #aabacc !important;
		color: #fff !important;
	}
	.imgimg{
		width: 116px;
		height: 116px;
		position: absolute;
		bottom: 13px;
		right: 62px;
	}
	.mbm-shipin {
		color: #d5eaf8;
	}

	.mbm-yinle {
		color: #fae1cf;
	}

	.tplinfo .tplicon {
		font-size: 115px;
		line-height: 115px;
		position: absolute;
		bottom: 26px;
		right: 62px;
	}
	.tplinfo .tp-icon-zhishi{
		color: #fae1cf;
		font-size: 100px;
		bottom: 20px;
	}

	.tplinfo .tplbutton {
		width: 160px;
		display: flex;
		align-items: center;
		justify-content: center;
		box-shadow: 0px 0px 10px #95b4ff;
		margin-top: 55px;
		height: 50px !important;
	}
	.tplbutton span{line-height: 1;}

	.tplinfo3>div {
		display: inline-block;
		line-height: 38px;
		padding: 0 14px;
		border-radius: 20px;
		border: 1px solid #e7e7e7;
		margin-right: 13px;
		min-width: 125px;
		text-align: center;
	}

	.tplinfo3>div:last-child {
		margin-right: 0px !important;

	}

	.tplinfo3 {
		font-size: 12px;
		color: #999;
		margin-top: 20px;
	}

	.cutline {
		width: 1px;
		height: 16px;
		background-color: #e7e7e7;
		margin: 0 10px;
	}

	.tplinfo2 {
		display: flex;
		align-items: center;
		color: #999;
		font-size: 14px;
		line-height: 16px;
		margin-top: 20px;
	}

	.tplinfo1 {
		font-size: 30px;
		line-height: 30px;
		margin-top: 30px;
	}

	.tplBottomR {
		width: 40px;
		height: 40px;
		border-radius: 8px;
		background-color: #e7e7e7;
		display: flex;
		align-items: center;
		cursor: pointer;
		justify-content: center;
	}

	.tplBottomL1 {
		font-size: 30px;
		color: #333;
		display: inline-block;
	}

	.tplBottomL2 {
		color: #999;
		display: inline-block;
		font-size: 14px;
		margin-left: 20px;
	}

	.tplBottomL {}

	.tplBottom {
		box-sizing: border-box;
		width: 100%;
		height: 123px;
		border-radius: 18px;
		border: 1px solid #e2e1de;
		margin-top: 51px;
		padding: 0 100px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.width1200 {
		width: 1200px;
		margin: 0 auto;
	}

	.tplinfo {
		width: 580px;
		height: 300px;
		border-radius: 15px;
		background-color: #ffffff;
		box-shadow: 0px 10px 20px #f2f2f2;
		padding-left: 78px;
		position: relative;
	}

	.tpllists {
		margin-top: 84px;
		display: flex;
		justify-content: space-between;
	}

	* {
		margin: 0;
		padding: 0;
		box-sizing: border-box;
	}

	.tplContainer {
		background-image: linear-gradient(#ecf3fc, #ffffff);
	}

	.tpltitle {
		font-size: 46px;
		line-height: 46px;
		text-align: center;
		padding-top: 75px;
	}


	.tplLists__head {
		margin: 90px 0;
	}

	.tplLists__title {
		font-size: 36px;
		text-align: center;
	}

	.tplLists__more {
		font-size: 14px;
		color: #285af9;
		cursor: pointer;
	}

	.tpl-list {
		display: flex;
		flex-direction: column;
		gap: 24px;
	}

	.tpl-card {
		display: flex;
		gap: 90px;
		padding: 40px 70px;
		background: #fff;
		border: 1px solid #e8e8e8;
		border-radius: 16px;
		cursor: pointer;
		transition: all 0.25s ease;
		box-shadow: 0 8px 32px rgba(40, 90, 249, 0.12);
	}

	.tpl-card:hover {
		box-shadow: 0 8px 32px rgba(40, 90, 249, 0.32);
	}

	.tpl-card__phone {
		position: relative;
		width: 240px;
		height: 480px;
		flex-shrink: 0;
	}

	.tpl-card__phone-inner {
		width: 240px;
		position: absolute;
		top: 0;
		left: 0;
		z-index: 1;
		overflow: hidden;
		height: 480px;
		border-radius: 23px;
		border: 5px solid #fff;
		box-shadow: 0 0 5px rgba(0, 0, 0, .2);
	}

	.tpl-card__screen {
		position: absolute;
		top: 3px;
		left: 3px;
		width: 224px;
		height: auto;
		border-radius: 16px;
		object-fit: cover;
		z-index: 1;
		box-shadow: 0 0 1px rgba(0, 0, 0, .2);
		padding-top: 5px;
	}

	.tpl-card__content {
		flex: 1;
		display: flex;
		flex-direction: column;
		min-width: 0;
		padding-top: 4px;
	}

	.tpl-card__top {
		margin-bottom: 24px;
	}

	.tpl-card__tag {
		display: inline-flex;
		align-items: center;
		gap: 4px;
		padding: 5px 12px;
		background: #f6fbff;
		border-radius: 6px;
		font-size: 12px;
		font-weight: 600;
		color: #285af9;
	}

	.tpl-card__tag-icon {
		color: #285af9;
		font-size: 12px;
	}

	.tpl-card__title {
		margin: 0 0 24px;
		font-size: 25px;
		font-weight: 700;
		color: #1a1a2e;
		line-height: 1.3;
	}

	.tpl-card__desc {
		margin: 0 0 18px;
		font-size: 15px;
		color: #888;
		line-height: 1.6;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
		overflow: hidden;
	}

	.tpl-card__features {
		display: flex;
		align-items: stretch;
		margin-bottom: 18px;
		overflow: hidden;
		border-top: 1px solid #e8e8e8;
		border-bottom: 1px solid #e8e8e8;
		padding: 20px 0;
		justify-content: space-between;
	}

	.tpl-card__feature-row {
		display: flex;
		align-items: center;
		gap: 10px;
		background: #fff;
	}

	.tpl-card__feature-num {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 45px;
		height: 45px;
		border-radius: 50%;
		background: #285af9;
		color: #fff;
		font-size: 20px;
		font-weight: 700;
		flex-shrink: 0;
	}

	.tpl-card__feature-text-box {
		display: flex;
		flex-direction: column;
		gap: 2px;
	}

	.tpl-card__feature-text {
		font-size: 17px;
		font-weight: 600;
		color: #1a1a2e;
		line-height: 1.3;
	}

	.tpl-card__feature-sub {
		font-size: 14px;
		color: #888;
		line-height: 1.3;
		margin-top: 2px;
	}

	.tpl-card__feature-arrow {
		display: flex;
		align-items: center;
		font-size: 25px;
		font-weight: 600;
		color: #d0d0d0;
		padding: 0 2px;
		flex-shrink: 0;
		background: #fff;
	}

	.tpl-card__stats {
		display: flex;
		gap: 45px;
		margin-bottom: 16px;
		flex-wrap: wrap;
	}

	.tpl-card__stat {
		display: flex;
		align-items: center;
		gap: 10px;
		padding: 7px 18px;
		border-radius: 10px;
		background-color: #f7fafe;
		transition: all 0.2s ease;
	}

	.tpl-card__stat-icon {
		color: #285af9;
		font-size: 30px;
		margin-right: 4px;
	}

	.tpl-card__stat-body {
		flex: 1;
		min-width: 0;
	}

	.tpl-card__stat-title {
		font-size: 17px;
		font-weight: 600;
		color: #1a1a2e;
		line-height: 1.3;
	}

	.tpl-card__stat-sub {
		font-size: 14px;
		color: #999;
		margin-top: 2px;
	}

	.tpl-card__footer {
		margin-top: auto;
		padding-top: 12px;
		text-align: right;
	}

	.tpl-card__preview-link {
		font-size: 14px;
		color: #285af9;
		transition: color 0.2s;
	}

	.tpl-card__preview-link:hover {
		color: #4d8aff;
	}
</style>
